import React from 'react'

import ItemTemplate from './ItemTemplate'
import ModalEditor from '../../components/ModalEditor.jsx'

import { getText, getLocale } from '../../lib/text.js'

/**
 *
 */

const Day = props => {
  const { item, routeId, i } = props
  return (
    <ItemTemplate
      {...props}
      title={
        <span>
          {getText("dia_1")}{props.daysCounter}{getText("dia_2")}
          {
            props.startDate ? (
              <small style={{fontSize: "80%", marginLeft: 10, color: "black"}}>
                ({
                  props.date 
                    ? props.date.locale(getLocale()).format("YYYY/MM/DD dddd")
                    : "YYYY/MM/DD dddd"
                })
              </small>
            ) : ""
          }
        </span>
      }
      description={item.description}
      subtitle={""}
      icon="calendar"
      modal={
        () => (
          <ModalEditor
            label={getText("Editar descripción del día")}
            onHide={() => props.onEndEdit()}
            onChange={text => props.editItem(routeId, i, "description", text)}
            initialValue={item.description || ""}
          />
        )
      }
    />
  )
}

export default Day
